import { createProductGrid } from "../molecules/product-grid";

export function createProductGrids(grids: HTMLElement[]) {
	if (grids) {
		grids.forEach((grid) => {
			createProductGrid(grid, {});
		});
	}
}
